import { GraphQLVehicleModelsRequester } from '@cobliteam/api-lib';
import type { Branding } from '@cobliteam/api-lib/src/__generated__/graphql';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

export const QUERY_KEY = 'VEHICLE_MODELS';

const graphQLVehicleModelsRequester = () => new GraphQLVehicleModelsRequester();

const useVehicleModels = () => {
  const useVehicleModelsQuery = (options?: Partial<UseQueryOptions<Branding[]>>) => {
    'use no memo'; // nested in a function the compiler skips; compiled alone it loses the outer scope
    return useQuery<Branding[]>({
      queryKey: [QUERY_KEY],
      ...options,
      queryFn: async () => graphQLVehicleModelsRequester().getVehicleModels(),
    });
  };

  return {
    useVehicleModelsQuery,
  };
};

export default useVehicleModels;
